/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { HttpCallsCountService } from './http-calls-counter.service';
import { Observable } from 'rxjs/index';
import { tap } from 'rxjs/operators';

@Injectable()
export class HttpCallsCounterInterceptor implements HttpInterceptor {
  constructor(protected readonly httpCallsService: HttpCallsCountService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    this.httpCallsService.increaseCallsCounter();
    return next.handle(req).pipe(
      tap(
        (resp) => {
          if (resp.type != 0) {
            this.httpCallsService.decreaseCallsCounter();
          }
        },
        () => this.httpCallsService.decreaseCallsCounter()
      )
    );
  }
}
